import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import  PackageListLayer  from '../components/package/PackageListLayer'

export const PackagePageList = () => {
  return (
<MasterLayout>
    <PackageListLayer/>
</MasterLayout>
  )
}
